<div class="qcontainer">
    <sha-create-service-appointment [associate]="associate" [address]="address" [vehicle]="vehicle">
    </sha-create-service-appointment>
</div>